import { render, staticRenderFns } from "./automation.vue?vue&type=template&id=60b5f98b&scoped=true"
import script from "./automation.vue?vue&type=script&lang=js"
export * from "./automation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b5f98b",
  null
  
)

export default component.exports